<!--
상품 추가
------------------------------------
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-auto">

            <div class="uk-modal-header">
                <h4>상품추가</h4>
            </div>

            <div class="uk-modal-body uk-padding-small">
                <div class="add-prod-component uk-flex uk-flex-around uk-flex-top uk-flex-wrap">
                    <!-- 이미지 -->
                    <div class="img">
                        <div class="blank-text" v-show="! inputs.p_img_url">
                            상품이미지
                        </div>
                        <img
                            v-show="inputs.p_img_url"
                            :src="inputs.p_img_url"
                        />

                        <!-- 업로드버튼 -->
                        <div class="uk-text-center uk-margin-top">
                            <button
                                type="button"
                                class="uk-button uk-button-small uk-button-white"
                                @click="$refs.upload.form()"
                            >
                                <i class="material-icons">cloud_upload</i>
                                이미지 업로드
                            </button>

                            <!-- 업로드 컴포넌트 -->
                            <upload
                                :csrf-token="csrfToken"
                                ref="upload"
                                @uploaded="listenUploaded"
                            ></upload>

                            <!-- 업로드 파일 ID -->
                            <input type="hidden" name="p_img_file_id" v-model="inputs.p_img_file_id" />
                        </div>

                    </div>

                    <!-- 상품정보 -->
                    <app-shipping-reg-fieldset class="prod" title="상품">
                        <div uk-grid class="uk-grid-small">
                            <app-input-ex
                                class="input uk-width-1-1 uk-margin-remove"
                                type="text"
                                input-size="small"

                                ref="p_name"
                                name="p_name"
                                v-model="inputs.p_name"
                                label="상품명"

                                :validate-rules="{required: true}"
                                required
                                required-layout="label-left"

                                placeholder="영문 상품명"
                            > </app-input-ex>

                            <app-input-ex
                                class="input uk-width-1-2@m uk-margin-remove"
                                type="text"
                                input-size="small"

                                ref="p_brand"
                                name="p_brand"
                                v-model="inputs.p_brand"
                                label="브랜드"
                            > </app-input-ex>

                            <app-input-ex
                                class="input uk-width-1-2@m uk-margin-remove"
                                type="text"
                                input-size="small"

                                ref="p_prod_code"
                                name="p_prod_code"
                                v-model="inputs.p_prod_code"
                                label="상품코드"

                                placeholder="회원사 자체 관리코드"
                            > </app-input-ex>

                            <app-input-ex
                                class="input uk-width-1-2@m uk-margin-remove"
                                type="text"
                                input-size="small"

                                ref="p_color"
                                name="p_color"
                                v-model="inputs.p_color"
                                label="색상"

                                :validate-rules="{required: true}"
                                required
                                required-layout="label-left"
                            > </app-input-ex>

                            <app-input-ex
                                class="input uk-width-1-2@m uk-margin-remove"
                                type="text"
                                input-size="small"

                                ref="p_amount"
                                name="p_amount"
                                v-model="inputs.p_amount"
                                label="수량"

                                :validate-rules="{required: true, numeric: true}"
                                required
                                required-layout="label-left"

                                placeholder="숫자로만 입력해 주세요"
                            > </app-input-ex>

                            <app-input-ex
                                class="input uk-width-1-2@m uk-margin-remove"
                                type="text"
                                input-size="small"

                                ref="p_size"
                                name="p_size"
                                v-model="inputs.p_size"
                                label="사이즈"

                                :validate-rules="{required: true}"
                                required
                                required-layout="label-left"
                            > </app-input-ex>

                            <app-input-ex
                                class="input uk-width-1-2@m uk-margin-remove"
                                type="text"
                                input-size="small"

                                ref="p_unit_price"
                                name="p_unit_price"
                                v-model="inputs.p_unit_price"
                                label="단가"

                                :validate-rules="{required: true}"
                                required
                                required-layout="label-left"

                                :placeholder="'1개 상품가격(' + regionCurrency + '), 숫자로만 입력'"
                            > </app-input-ex>

                            <app-input-ex
                                class="input uk-width-1-2@m uk-margin-remove"
                                type="text"
                                input-size="small"

                                ref="p_vender_mall"
                                name="p_vender_mall"
                                v-model="inputs.p_vender_mall"
                                label="쇼핑몰"

                                placeholder="예시 : amazon.com"
                            > </app-input-ex>

                            <app-input-ex
                                class="input uk-width-1-2@m uk-margin-remove"
                                type="text"
                                input-size="small"

                                ref="p_vender_code"
                                name="p_vender_code"
                                v-model="inputs.p_vender_code"
                                label="해외상품코드"
                            > </app-input-ex>

                            <app-input-ex
                                class="input uk-width-1-1 uk-margin-remove"
                                type="text"
                                input-size="small"

                                ref="p_vender_url"
                                name="p_vender_url"
                                v-model="inputs.p_vender_url"
                                label="상세URL"

                                :validate-rules="{required: true}"
                                required
                                required-layout="label-left"
                            > </app-input-ex>

                            <app-input-ex
                                class="input uk-width-1-1 uk-margin-remove"
                                type="text"
                                input-size="small"

                                ref="p_img_url"
                                name="p_img_url"
                                v-model="inputs.p_img_url"
                                label="이미지URL"

                                :validate-rules="{required: true}"
                                required
                                required-layout="label-left"
                            > </app-input-ex>


                            <app-prod-hscode-on-addprod
                                class="input uk-width-1-1 uk-margin-remove"

                                ref="p_hscode"
                                name="p_hscode"
                                v-model="inputs.p_hscode"

                                :hscode-options="hscodeOptions"
                                :hscodefull-options="hscodefullOptions"

                                :validate-rules="{required: true}"
                                required
                                required-layout="label-left"
                            ></app-prod-hscode-on-addprod>

                            <app-input-ex
                                class="input uk-width-1-2@m uk-margin-remove"
                                type="text"
                                input-size="small"

                                ref="p_type_name"
                                name="p_type_name"
                                v-model="inputs.p_type_name"
                                label="품목명"

                                placeholder="e.g. CLOTHES"
                                desc-msg="영문으로 작성하세요"

                                :validate-rules="{required: true}"
                                required
                                required-layout="label-left"
                            > </app-input-ex>

                            <app-input-ex
                                class="input uk-width-1-1 uk-margin-remove"
                                type="textarea"
                                input-size="small"

                                ref="p_memo"
                                name="p_memo"
                                v-model="inputs.p_memo"
                                label="관리메모"

                                :textarea-rows="3"
                            > </app-input-ex>
                        </div>
                    </app-shipping-reg-fieldset>


                    <!-- 해외오더정보 -->
                    <app-shipping-reg-fieldset class="vendor" title="해외오더">
                        <app-input-ex
                            class="input"
                            type="text"
                            input-size="small"

                            ref="p_buy_order_code"
                            name="p_buy_order_code"
                            v-model="inputs.p_buy_order_code"
                            label="해외주문번호"
                        > </app-input-ex>

                        <app-input-ex
                            class="input"
                            type="radio"
                            input-size="small"

                            ref="p_shipping_center"
                            name="p_shipping_center"
                            v-model="inputs.p_shipping_center"
                            label="배송지"

                            :options="shippingCenterOptions"
                        > </app-input-ex>

                        <app-input-ex
                            class="input"
                            type="text"
                            input-size="small"

                            ref="p_tracking_no"
                            name="p_tracking_no"
                            v-model="inputs.p_tracking_no"
                            label="트래킹번호"
                        > </app-input-ex>

                        <app-input-ex
                            class="input"
                            type="text"
                            input-size="small"

                            ref="p_buy_unit_price"
                            name="p_buy_unit_price"
                            v-model="inputs.p_buy_unit_price"
                            label="구입단가"

                            :validate-rules="{required: true}"
                            required
                            required-layout="label-left"

                            :placeholder="'1개 상품가격('+inputs.regionCurrency+') *통관시 전송되는 금액'"
                        > </app-input-ex>
                    </app-shipping-reg-fieldset>


                    <!-- 회원사주문정보 -->
                    <app-shipping-reg-fieldset class="order" title="회원사 주문정보">
                        <app-input-ex
                            class="input"
                            type="text"
                            input-size="small"

                            ref="hp_order_name"
                            name="hp_order_name"
                            v-model="inputs.hp_order_name"
                            label="주문자"
                        > </app-input-ex>

                        <app-input-ex
                            class="input"
                            type="text"
                            input-size="small"

                            ref="hp_order_id"
                            name="hp_order_id"
                            v-model="inputs.hp_order_id"
                            label="주문자ID"
                        > </app-input-ex>

                        <app-input-ex
                            class="input"
                            type="text"
                            input-size="small"

                            ref="hp_order_at"
                            name="hp_order_at"
                            v-model="inputs.hp_order_at"
                            label="주문일"

                            placeholder="ex) 2017-01-01"
                        > </app-input-ex>

                        <app-input-ex
                            class="input"
                            type="text"
                            input-size="small"

                            ref="hp_order_market"
                            name="hp_order_market"
                            v-model="inputs.hp_order_market"
                            label="마켓명"
                        > </app-input-ex>

                        <app-input-ex
                            class="input"
                            type="text"
                            input-size="small"

                            ref="hp_order_seller"
                            name="hp_order_seller"
                            v-model="inputs.hp_order_seller"
                            label="셀러ID"
                        > </app-input-ex>

                        <app-input-ex
                            class="input"
                            type="text"
                            input-size="small"

                            ref="hp_order_unit_price_krw"
                            name="hp_order_unit_price_krw"
                            v-model="inputs.hp_order_unit_price_krw"
                            label="판매단가"

                            placeholder="KRW"
                        > </app-input-ex>

                        <app-input-ex
                            class="input"
                            type="text"
                            input-size="small"

                            ref="hp_sp_prod_code"
                            name="hp_sp_prod_code"
                            v-model="inputs.hp_sp_prod_code"
                            label="배송상품코드"

                            desc-msg="중복등록제한용"
                        > </app-input-ex>
                    </app-shipping-reg-fieldset>

                </div>

            </div>


            <div class="uk-modal-footer uk-text-right">
                <!-- 설명/경고 -->
                <div class="uk-text-meta uk-margin-small-bottom">
                    * 현재 배송에 상품이 추가됩니다.
                </div>

                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: plus-circle"></span>
                    상품추가
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
            'upload': require('./shipping-reg/img-upload.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,
            /**
             * 하우스ID
             */
            houseId: {
                type: Number,
                default: null,
            },
            /**
             * 지역통화
             */
            regionCurrency: {
                type: String,
                default: null,
            },
            /**
             * HS코드 옵션배열
             */
            hscodeOptions: {
                type: Array,
                default: () => {return [];}
            },

            /**
             * hs코드(코드별 전체품목) 옵션배열
             */
            hscodefullOptions: {
                type: Array,
                default: () => {return [];}
            },

            /**
             * 배송지 옵션배열
             */
            shippingCenterOptions: {
                type: Array,
                default: [],
            },
        },
        data: function () {
            return {
                // 입력값 object
                inputs: {
                    // 상품정보
                    p_name: null,
                    p_brand: null,
                    p_prod_code: null,
                    p_color: null,
                    p_size: null,
                    p_amount: null,
                    p_unit_price: null,
                    p_vender_mall: null,
                    p_vender_code: null,
                    p_vender_url: null,
                    p_img_url: null,
                    p_img_file_id: null,
                    p_hscode: null,
                    p_type_name: null,
                    p_memo: null,

                    // 해외오더
                    p_buy_order_code: null,
                    p_shipping_center: null,
                    p_tracking_no: null,
                    p_buy_unit_price: null,

                    // 회원사 주문정보
                    hp_order_name: null,
                    hp_order_id: null,
                    hp_order_at: null,
                    hp_order_market: null,
                    hp_order_seller: null,
                    hp_order_unit_price_krw: null,
                    hp_sp_prod_code: null,
                },
            };
        },
        computed: {
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {
                UIkit.modal(this.$el).show();
            },
            /**
             * 상품추가
             */
            add() {
                // 입력값 초기화
                this.inputs = {
                    // 상품정보
                    p_name: null,
                    p_brand: null,
                    p_prod_code: null,
                    p_color: null,
                    p_size: null,
                    p_amount: null,
                    p_unit_price: null,
                    p_vender_mall: null,
                    p_vender_code: null,
                    p_vender_url: null,
                    p_img_url: null,
                    p_img_file_id: null,
                    p_hscode: null,
                    p_type_name: null,
                    p_memo: null,

                    // 해외오더
                    p_buy_order_code: null,
                    p_tracking_no: null,
                    p_shipping_center: '',
                    p_buy_unit_price: null,

                    // 회원사 주문정보
                    hp_order_name: null,
                    hp_order_id: null,
                    hp_order_at: null,
                    hp_order_market: null,
                    hp_order_seller: null,
                    hp_order_unit_price_krw: null,
                    hp_sp_prod_code: null,
                };

                // 폼띄우기
                this.displayForm();
            },

            /**
             * 상품복사 추가
             * @param prod_id 복사할 상품ID
             */
            copy(prod_id) {
                // 값이 전달되었는지 검증\
                if (! prod_id) {
                    alert('선택된 상품이 없습니다');
                    return ;
                }

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/prods/' + prod_id + '/prod-info',
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    let prod = response.prod;
                    let house_prod = response.house_prod;
                    let house = response.house;

                    // 상품정보 설정
                    _.assignIn(this.inputs, {
                        // 상품정보
                        p_name: prod.name,
                        p_brand: prod.brand,
                        p_prod_code: prod.prod_code,
                        p_color: prod.color,
                        p_size: prod.size,
                        p_amount: prod.amount,
                        p_unit_price: prod.unit_price,
                        p_vender_mall: prod.vender_mall,
                        p_vender_code: prod.vender_code,
                        p_vender_url: prod.vender_url,
                        p_img_url: prod.img_url,
                        p_img_file_id: null,
                        p_hscode: prod.hscode,
                        p_type_name: prod.type_name,
                        p_memo: prod.memo,

                        // 해외오더
                        p_buy_order_code: prod.buy_order_code,
                        p_shipping_center: prod.shipping_center,
                        p_tracking_no: prod.tracking_no,
                        p_buy_unit_price: prod.buy_unit_price,

                        // 회원사 주문정보
                        hp_order_name: house_prod.order_name,
                        hp_order_id: house_prod.order_id,
                        hp_order_at: house_prod.order_at,
                        hp_order_market: house_prod.order_market,
                        hp_order_seller: house_prod.order_seller,
                        hp_order_unit_price_krw: house_prod.order_unit_price_krw,
                        hp_sp_prod_code: house_prod.sp_prod_code,
                    });

                    // 폼띄우기
                    this.displayForm();
                })


            },

            /**
             * 상품추가 submit
             */
            submit() {
                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: '/houses/' + this.houseId + '/add-prod',
                    data: _.merge({
                        '_token': this.csrfToken,
                    }, this.inputs),
                    success: (response, textStatus, jqXHR) => {
                        // 검증실패인 경우
                        if (! response.is_success) {
                            // 메세지얼럿
                            alert(response.msg);

                            // 각 input에 실패원인 표시
                            _.each(response.errors, (msg, key) => {
                                if (this.$refs[key]) {
                                    this.$refs[key].setState('error', msg);
                                }
                            });


                            return;
                        }

                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.move(response.move_to);
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },

            /**
             * 업로드 이벤트 리스너
             */
            listenUploaded(uploaded) {
                this.inputs.p_img_file_id = uploaded.id;
                this.inputs.p_img_url = uploaded.full_url;
                this.displayForm();
                //console.log(uploaded);
            },
        },
    }
</script>

<!-- 하위컴포넌트의 요소에 영향을 주기위해서 scope 설정하지않음. -->
<style lang="scss">
    .add-prod-component{
        // 이미지
        .img {
            width: 150px;
            margin: 30px 10px 0 0;

            .blank-text {
                border: 1px solid #999;
                text-align: center;
                padding: 50px 0;
                background-color: #fff;
                color: #999;
            }

            img {
                width: 150px;
            }
        }

        fieldset.uk-fieldset {
            margin: 10px;

            // 소제목
            .uk-legend{
                font-size: 1.125rem;
            }


            // 상품정보
            &.prod {
                width: 500px;
            }

            // 해외오더
            &.vendor {
                width: 250px;
            }

            // 회원사주문정보
            &.order {
                width: 250px;

            }
        }
    }
</style>